<template>
	<div id="class" class="columns">
		<div class="column">
			<div class="card">
				<header class="card-header">
					<section class="card-header-title">Beroep Resultaten</section>
				</header>
				<header class="card-header" style="background-color:#eeeeee;padding: 12px;">
					<nav class="level">
						<div class="level-left">
							<div class="level-item">
								<b-field>
									<b-select
										icon="school"
										label="school"
										placeholder="Kies een school"
										v-model="selected_school"
									>
										<option value="0">Alles</option>
										<option
											v-for="item in schoolswithobjection"
											:value="item.tbl_school.id"
											:key="item.tbl_school.id"
										>{{item.tbl_school.schoolnumber}} - {{ item.tbl_school.name }}</option>
									</b-select>
								</b-field>
							</div>
							<div class="level-item">
								<b-taglist attached>
									<b-tag size="is-medium" type="is-primary">Totaal in beroep</b-tag>
									<b-tag size="is-medium" type="is-warning">
										<b>{{studentData.length}}</b>
									</b-tag>
								</b-taglist>
							</div>
						</div>
					</nav>
				</header>

				<div style="padding:5px;">
					<b-table
						:data="studentData"
						default-sort="tbl_school.name"
						:bordered="false"
						:narrowed="true"
						:striped="true"
						:loading="loading"
						:paginated="isPaginated"
						:per-page="perPage"
						:current-page.sync="currentPage"
						:pagination-simple="isPaginationSimple"
						:default-sort-direction="defaultSortDirection"
					>
						<template slot-scope="props">
							<b-table-column
								label="Leerlingnr"
								field="student_number"
								sortable
								centered
							>{{ padwithZeros(props.row.tbl_school.schoolnumber) }}{{ padwithZeros(props.row.tbl_conf_class.testgroup)}}{{ padwithZeros(props.row.student_number) }}</b-table-column>
							<b-table-column
								label="School"
								field="tbl_school.name"
								sortable
							>{{ props.row.tbl_school.name }}</b-table-column>
							<b-table-column
								label="Firstname"
								field="tbl_student.firstname"
							>{{ props.row.tbl_student.firstname }}</b-table-column>
							<b-table-column
								label="Achternaam"
								field="tbl_student.surname"
							>{{ props.row.tbl_student.surname }}</b-table-column>
							<b-table-column
								label="Advies"
								field="tbl_student.tbl_further_education.director_advice"
							>{{ props.row.tbl_student.tbl_further_education.director_advice}}</b-table-column>
							<b-table-column
								label="Uitslag"
								field="tbl_student.tbl_further_education.vw_efo_uitslag.Uitslag"
							>{{ props.row.tbl_student.tbl_further_education.vw_efo_uitslag.Uitslag}}</b-table-column>

							<b-table-column label="Resultaat Beroep">
								<b-select
									placeholder="Select a name"
									v-model="props.row.tbl_student.tbl_further_education.objection_result_id"
									size="is-small"
									@change.native="objection_save(props.row.student_id,props.row);"
								>
									<option v-for="option in Objections" :value="option.id" :key="option.id">{{ option.name }}</option>
								</b-select>
							</b-table-column>
						</template>
						<template slot="empty">
							<section class="section">
								<div class="content has-text-grey has-text-centered">
									<p>
										<b-icon icon-pack="far" icon="exclamation-triangle" size="is-large"></b-icon>
									</p>
									<p>Nothing here.</p>
								</div>
							</section>
						</template>
					</b-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Axios from "axios";
import Cookies from "js-cookie";
import { API_ROOT } from "../config";

var instance = Axios.create({
	baseURL: API_ROOT,
	timeout: 60000
});

export default {
	name: "class",

	data: function() {
		return {
			Objections: [],
			selected_objections: [],
			schoolswithobjection: [],
			selected_school: null,
			studentData: [],
			schools: [],
			currentschoolyear: 0,
			loading: true,
			access: Cookies.get("access"),
			user: Cookies.getJSON("user"),
			isEmpty: false,
			isPaginated: true,
			isPaginationSimple: false,
			defaultSortDirection: "asc",
			currentPage: 1,
			perPage: 15
		};
	},
	created: function() {
		//this.getUnits()
		if (_.isUndefined(this.access == 0)) {
			this.$router.push({
				path: "/"
			});
		}
		this.getSchoolsWithObjections();

		this.getCurrentschoolyear();

		this.selected_school = 0;
	},

	watch: {
		selected_school(val) {
			console.log("Show all schools");
			console.log("school_id:" + val);

			this.getSelectedClass(val);
		}
	},
	methods: {
		getCurrentschoolyear() {
			var self = this;

			instance.get("/current-schoolyear").then(function(response) {
				console.log(response.data.data);

				self.currentschoolyear = response.data.data;
				self.getObjections();
			});
		},
		objection_save(id, value) {
			console.log(id);

			var self = this;
			this.$nextTick(function() {
				// DOM is now updated
				// `this` is bound to the current instance

				console.log(value);
				instance
					.post("/further-education-objection", {
						student_id: id,
						objection_result_id:
							value.tbl_student.tbl_further_education.objection_result_id
					})
					.then(function(response) {
						console.log(response.data.data);
					});
			});
		},
		padwithZeros(string) {
			return _.padStart(string, 2, "0");
		},
		getObjections: function() {
			var self = this;

			instance
				.get("/objectionresult/currentyear/" + this.currentschoolyear.id)
				.then(function(response) {
					console.log("Get schools...");
					console.log(response.data.data);

					self.Objections = response.data.data;
				});
		},
		handleClick(studentid) {
			console.log("studentid: " + studentid);
			console.log(this.user.data);
			this.$router.push({
				path: "/studentvoorzitter/" + studentid
			});
		},
		getSelectedClass: function(id) {
			console.log(id);
			self = this;
			//todo:
			this.loading = true;

			instance.get("/student-class/objection/" + id).then(function(response) {
				console.log(self.user.role_id);
				console.log(response.data.data);

				if (self.user.role_id == 5) {
					self.studentData = _.filter(response.data.data, function(o) {
						return S(
							o.tbl_student.tbl_further_education.vw_efo_uitslag.Uitslag
						).contains("VSBO");
					});
				} else if (self.user.role_id == 6) {
					self.studentData = _.filter(response.data.data, function(o) {
						return (
							S(
								o.tbl_student.tbl_further_education.vw_efo_uitslag.Uitslag
							).contains("AGO") ||
							S(
								o.tbl_student.tbl_further_education.vw_efo_uitslag.Uitslag
							).contains("Niet toelaatbaar/Terug Funderend")
						);
					});
				} else {
					self.studentData = response.data.data;
				}

				self.loading = false;
				console.log(self.studentData);
			});
		},
		getSchoolsWithObjections: function() {
			self = this;
			//todo:

			instance.get("/student-class/objection/0").then(function(response) {
				//TODO: Filter by role_id!
				if (self.user.role_id == 5) {
					self.schoolswithobjection = _.filter(response.data.data, function(o) {
						return S(
							o.tbl_student.tbl_further_education.vw_efo_uitslag.Uitslag
						).contains("VSBO");
					});
				} else if (self.user.role_id == 6) {
					self.schoolswithobjection = _.filter(response.data.data, function(o) {
						return (
							S(
								o.tbl_student.tbl_further_education.vw_efo_uitslag.Uitslag
							).contains("AGO") ||
							S(
								o.tbl_student.tbl_further_education.vw_efo_uitslag.Uitslag
							).contains("Niet toelaatbaar/Terug Funderend")
						);
					});
				} else {
					self.schoolswithobjection = response.data.data;
				}
				self.schoolswithobjection = _.uniqBy(
					self.schoolswithobjection,
					"tbl_school.id"
				);
				console.log("Schools with Objection....");
				console.log(self.schoolswithobjection);
			});
		}
	}
};
</script>
<style scoped>
</style>
